import * as React from 'react';
import { NavLink } from 'react-router-dom';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { BottoneAPI, Trad, BaseComponent, ChiamaAPI, Tipo } from '../components/';

interface ILogState {
    LogCatParam: string;
    LogCat?: Glob.LogCat;
    Abilitato: boolean;
}

export class Log extends React.Component<Glob.IRouteGlobaleProps, ILogState> {

    public constructor(props: any) {
        super(props);
        let LogCatParam = (this.props.match.params as any).LogCat;
        let LCP: Glob.LogCat | undefined = undefined;

        let A = false;
        switch ((this.props.match.params as any).Abilita) {
            case "1":
            case "true":
            case "vero":
            case "si":
            case "yes":
            case "y":
                A = true;
            case "0":
            case "false":
            case "falso":
            case "no":
            case "n":
                for (var LC in Glob.LogCat) {
                    if (LogCatParam == Glob.LogCat[LC]) {
                        LCP = LC as Glob.LogCat;
                    }
                }
                break;
        }

        this.state = { LogCat: LCP, LogCatParam: LogCatParam, Abilitato: A };
    }

    public render() {
        let LC = JSON.stringify(Glob.LogAbilita(this.state.Abilitato, this.state.LogCat));
        return <pre>{LC}</pre>;
    }
}


// WEBPACK FOOTER //
// ./src/form/Log.tsx